import React from "react";
import { Link } from "react-router-dom";
import { Fingerprint, MapPinned, ScrollText, ArrowRight } from "lucide-react";

/**
 * The three-step onboarding band. Used prominently on the homepage.
 */
export default function FirstStepsBand() {
  const steps = [
    { i: <Fingerprint size={22}/>, t: "Verify your citizenship", d: "Quick and private. No visas, no bank checks, no extra papers." },
    { i: <MapPinned    size={22}/>, t: "Choose your land or home", d: "See every cost upfront — land price, legal fees, monthly plan." },
    { i: <ScrollText   size={22}/>, t: "Register your title",       d: "Independent lawyers handle the paperwork. Deed appears in your name." },
  ];
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="first-steps-band">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ How to start · Three steps</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          Simple. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>No confusion.</span>
        </h2>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          {steps.map((s, i) => (
            <div key={s.t} className="mv-card p-6 h-full relative" data-testid={`first-step-${i+1}`}>
              <div className="absolute top-4 right-4 font-display text-3xl" style={{ color: "rgba(212,175,55,0.35)" }}>{i+1}</div>
              <div className="w-11 h-11 rounded-2xl flex items-center justify-center mv-green-text mb-4" style={{ background: "rgba(212,175,55,0.16)" }}>{s.i}</div>
              <div className="font-display text-lg mv-green-text">{s.t}</div>
              <p className="mt-2 text-[14px]" style={{ color: "var(--mv-muted)" }}>{s.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Link to="/register-interest" className="btn-gold" data-testid="first-steps-start">
            Start step 1 <ArrowRight size={16}/>
          </Link>
        </div>
      </div>
    </section>
  );
}
